import * as yup from 'yup';

export const commonRecalProposalSetValidation: { [x: string]: any; } = {
    proposalSetName: yup.string().required("Missing."),
};

export const commonRecalProposalSetDtlValidation: { [x: string]: any; } = {
    companyCode: yup.string().required("Missing."),
    proposalNo: yup.string().required("Missing."),
};

export const createRecalProposalSetValidation: { [x: string]: any; } = {
    ...commonRecalProposalSetValidation,
};
export const createRecalProposalSetDtlValidation: { [x: string]: any; } = {
    ...commonRecalProposalSetDtlValidation,
};

export const createRecalProposalSetValidationSchema = yup.object().shape(createRecalProposalSetValidation);
export const createRecalProposalSetDtlValidationSchema = yup.object().shape(createRecalProposalSetDtlValidation);

